
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"id":"Ellipse_9","data-name":"Ellipse 9","cx":"12","cy":"12","r":"12","fill":"#fff"}}),_c('g',{attrs:{"id":"google-icon","transform":"translate(4.611 4.998)"}},[_c('path',{attrs:{"id":"Path_19459","data-name":"Path 19459","d":"M137.751 108.294a6.428 6.428 0 00-.158-1.533h-7.043v2.783h4.134a3.665 3.665 0 01-1.533 2.434l-.014.093 2.227 1.725.154.015a7.334 7.334 0 002.234-5.517","transform":"translate(-123.049 -100.627)","fill":"#4285f4"}}),_c('path',{attrs:{"id":"Path_19460","data-name":"Path 19460","d":"M20.625 162.387a7.149 7.149 0 004.967-1.817l-2.367-1.834a4.439 4.439 0 01-2.6.75 4.515 4.515 0 01-4.267-3.117l-.088.007-2.315 1.792-.03.084a7.5 7.5 0 006.7 4.134","transform":"translate(-13.125 -147.386)","fill":"#34a853"}}),_c('path',{attrs:{"id":"Path_19461","data-name":"Path 19461","d":"M3.234 76.2a4.618 4.618 0 01-.25-1.483 4.852 4.852 0 01.242-1.483v-.1L.877 71.312l-.077.036a7.485 7.485 0 000 6.734L3.234 76.2","transform":"translate(0 -67.215)","fill":"#fbbc05"}}),_c('path',{attrs:{"id":"Path_19462","data-name":"Path 19462","d":"M20.625 2.9a4.157 4.157 0 012.9 1.117l2.117-2.067A7.206 7.206 0 0020.625 0a7.5 7.5 0 00-6.7 4.134l2.425 1.883A4.534 4.534 0 0120.625 2.9","transform":"translate(-13.125)","fill":"#eb4335"}})])])
          )
        }
      }
    